import {Component, EventEmitter, forwardRef, Input, OnChanges, OnDestroy, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, FormBuilder, FormControl, NG_VALUE_ACCESSOR} from "@angular/forms";
import {FileManagerTag} from "../../interface/file-manager-tag";
import {ReplaySubject} from "rxjs";
import {first} from "rxjs/operators";
import {FileManagerTagService} from "../../services/file-manager-tag.service";
import {MatSelectChange} from "@angular/material/select";

@Component({
  selector: 'app-dict-tag-file-manager',
  templateUrl: './dict-tag-file-manager.component.html',
  styleUrls: ['./dict-tag-file-manager.component.scss'],
  providers: [
    {provide: NG_VALUE_ACCESSOR, multi: true, useExisting: forwardRef(() => DictTagFileManagerComponent)}
  ]
})
export class DictTagFileManagerComponent implements OnInit, ControlValueAccessor, OnDestroy, OnChanges{
  @Input() label: string;
  @Input() tagType?: string = null;
  @Input() multiple = false;
  @Input() control: FormControl = null;
  @Input() required = false;
  @Input() noneEntry = false;
  @Output() selectedDict: EventEmitter<FileManagerTag> = new EventEmitter<FileManagerTag>();
  @Output() selectedMultipleDict: EventEmitter<FileManagerTag[]> = new EventEmitter<FileManagerTag[]>();
  @Output() availableItems: EventEmitter<FileManagerTag[]> = new EventEmitter<FileManagerTag[]>();

  externalControl = true;
  disabled = false;
  items: FileManagerTag[] = [];
  value?: number = null;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);


  constructor(
    private fileManagerTagService: FileManagerTagService,
    private fb: FormBuilder,
  ) { }

  onChange: any = () => { };
  onTouched: any = () => { };


  ngOnInit(): void {

    this.fileManagerTagService.getTagDictSubject()
      .pipe(first())
      .subscribe((items: FileManagerTag[]) => {
        this.items = items;
        this.items.sort((a, b) => {
          return (a.name ).localeCompare(b.name );
        });
      });

    if (this.control === null) {
      this.control = new FormControl('');
      this.externalControl = false;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  ngOnChanges(): void {
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  setDisabledState(isDisabled: boolean): void {
    if (this.externalControl) {
      return;
    }

    if (isDisabled) {
      this.control.disable();
    } else {
      this.control.enable();
    }

    this.disabled = isDisabled;
  }

  writeValue(value: any): void {
    if (this.externalControl) {
      return;
    }

    this.control.setValue(value);
    this.value = value;
  }

  onSelectionChange(e: MatSelectChange): void {
    this.value = e.value;
    this.onChange(this.value);
  }

  clearValue(): void {
    this.control.setValue(this.multiple ? [] : '');
    this.writeValue(this.multiple ? [] : '');
    this.onChange(this.value);
  }

}
